import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';
import { Colors } from '../../../utils/resources/colors';

export interface GenericTabCSSStyle extends UIComponentCSSStyle
{
    getHeaderTitleCSSStyle(): object;
    getHeaderTitleDivCSSStyle(): object;
    getTabTitleDivCSSStyle(): object;
    getTabHeaderCSSStyle(): object;
    getTabLinkCSSStyle(isSelected: boolean): object;
    getTabContentCSSStyle(): object;
    getTitleDivCSSStyle(): object;
    getPipeCSSStyle(): object;

    getMobileWrapperCSSStyle(): object;
    getMobileHeaderTitleCSSStyle(): object;
    getMobileHeaderTitleDivCSSStyle(): object;
    getMobileTabHeaderCSSStyle(): object;
    getMobileTabLinkCSSStyle(isSelected: boolean): object;
    getMobileTabContentCSSStyle(): object;
    getMobileTitleDivCSSStyle(): object;
}

export class GenericTabCSSStyleImpl extends UIComponentCSSStyleImpl implements GenericTabCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            // height: "485px",
            display: "flex",
            width: "100%",
            justifyContents: "center",
            flexDirection: "row",
            paddingLeft: "5%",
            paddingRight: "5%",
            flexFlow: "row wrap"
        };
    }
    getTabHeaderCSSStyle(): object 
    {
        return {
            // height: "40px",
            width: "100%",
            display: "flex",
            position: "relative",
            flexDirection: "row",
            flexFlow: "row wrap",
        };
    }

    getHeaderTitleCSSStyle(): object 
    {
        return {
            display: "inline-block",
            // textAlign: "left",
            // height: "30px",
            paddingTop: "5px",
            fontWeight: 800,
            letterSpacing: 0,
            float: "left",
            fontSize: "40px",
            color: "#221E20",
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "32px",
            cursor: "pointer",
            width:"100%"
        };
    }

    getTabTitleDivCSSStyle(): object 
    {
        return {

        };
    }

    getHeaderTitleDivCSSStyle(): object 
    {
        return {
            flex: 2
        };
    }

    getTabLinkCSSStyle(isSelected: boolean): object {
        return {
            display: "inline-block",
            textAlign: "center",
            height: "25px",
            paddingTop: "8.5px",
            fontWeight: 900,
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            fontSize: "18px",
            color: isSelected ? "#ED0C6E" : "#898989",
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "25px",
            cursor: "pointer"
        };
    }

    getTitleDivCSSStyle(): object 
    {
        return {
            display: "inline",
            cursor: "pointer",
            textAlign: "right"
        };
    }

    getPipeCSSStyle(): object {
        return {
            display: "inline",
            paddingLeft: "14px",
            paddingRight: "14px",
            paddingTop: "10px",
            color: this.getResources().getColor(Colors.color_15)
        };
    }

    getTabContentCSSStyle(): object 
    {
        return {
            // backgroundColor: this.getResources().getColor(Colors.color_5),
            width:"100%",
        };
    }




    getMobileWrapperCSSStyle(): object
    {
        return {
            // height: "485px",
            display: "flex",
            width: "100%",
            justifyContents: "center",
            flexDirection: "row",
            flexFlow: "row wrap"
        };
    }
    getMobileTabHeaderCSSStyle(): object 
    {
        return {
            // height: "40px",
            width: "100%",
            display: "flex",
            position: "relative",
            flexDirection: "row",
            flexFlow: "row wrap",
        };
    }

    getMobileHeaderTitleCSSStyle(): object 
    {
        return {
            display: "inline-block",
            // textAlign: "left",
            width:"100%",
            // height: "30px",
            paddingTop: "5px",
            fontWeight: 800,
            letterSpacing: 0,
            float: "left",
            fontSize: "15px",
            color: "#221E20",
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            cursor: "pointer"
        };
    }


    getMobileHeaderTitleDivCSSStyle(): object 
    {
        return {
            flex: 2
        };
    }

    getMobileTabLinkCSSStyle(isSelected: boolean): object {
        return {
            display: "inline-block",
            textAlign: "center",
            height: "15px",
            paddingTop: "6px",
            fontWeight: 900,
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            fontSize: "12px",
            color: isSelected ? "#ED0C6E" : "#898989",
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "15px",
            cursor: "pointer"
        };
    }

    getMobileTitleDivCSSStyle(): object 
    {
        return {
            display: "inline",
            cursor: "pointer",
            textAlign: "right"
        };
    }

    getMobileTabContentCSSStyle(): object 
    {
        return {
            // backgroundColor: this.getResources().getColor(Colors.color_5),
            width:"100%",
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/tabs/generictabcss.tsx